import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { NudgeContainer } from './components/nudge-container';
import { NudgeBotMessageContainer } from './components/nudge-bot-message-container';
import { NudgeBotMessageAvatar } from './components/nudge-bot-message-avatar';
import { NudgeBotMessageCloud } from './components/nudge-bot-message-cloud';
import { useTheme } from 'styled-components';
import { NudgeBlurrer } from './components/nudge-blurrer';
import { useAppDispatch, useAppSelector } from '../../../common/store';
import { chatSelector } from '../../../common/store/chat/selectors';
import { NudgeBotMessageCloudContainer } from './components/nudge-bot-message-cloud-container';
import { CrossIcon } from '../../components/icons/cross-icon';
import { CrossIconContainer } from './components/nudge-cross-icon-container';
import { setIsNudgeOpen, setIsOpen } from '../../../common/store/app-state/app-state-slice';
import { sendMessageLogSubmission } from '../../../common/store/chat/thunks/send-message-log';
import { ChatContext } from '../../contexts/chat-context';
import VurbalizeEvents from '../../../common/types/dto/chat/vurbalize-events';
import { getQueryParamValue } from '../../utils/get-query-param-value';
import getMessageByVurablizeEvent from '../../utils/get-message-by-vurablize-event';
import { Plug } from '../../components/plug';
import { NudgeMessageContainer } from './styles';
import { shouldDisplay } from '../../../common/store/app-state/thunks/should-display';
import { PostShouldDisplayResponseDto } from '../../../common/types/dto/app/post-should-display-response-dto';
import { setReqNudgeConfig } from '../../../common/store/chat/chat-slice';
const Nudge = () => {
  const theme = useTheme();
  const storeMessages = useAppSelector(chatSelector);
  const isLANudge = useAppSelector((state) => state['app-state'].isLANudge);
  const dispatch = useAppDispatch(); // Make sure useAppDispatch returns AppDispatch (typed for thunks)
  const { agentTurnId, lastMessage } = useContext(ChatContext);
  const [showNudge, setShowNudge] = useState(false);


  const closeNudge = () => {
    dispatch(setIsNudgeOpen(false));
    dispatch(sendMessageLogSubmission({ data: {
      message: getMessageByVurablizeEvent(VurbalizeEvents.NUDGE_CLOSED),
      event_name: VurbalizeEvents.NUDGE_CLOSED,
      event_data: {
        timestamp: Date.now(),
      },
    }}))
  }
  const isOpen = useAppSelector(
    (state) => state['app-state'].isOpen
  );
  const nudgeMessage = useMemo(
    () => storeMessages.messages[storeMessages.messages.length - 1]?.is_nudge ? storeMessages.messages[storeMessages.messages.length - 1]?.value : '',
    [storeMessages.messages.length, storeMessages.messages],
  );
  useEffect(() => {
    if (!nudgeMessage || !showNudge || isOpen) return;
    dispatch(sendMessageLogSubmission({
      data: {
        message: storeMessages.buffer,
        turn_id: agentTurnId,
        event_name: VurbalizeEvents.NUDGE_MESSAGE_TEXT,
        event_data: {
          timestamp: Date.now(),
          messageContent: nudgeMessage,
          searchTerm: getQueryParamValue('utm_term'),
        },
        html: '',
        title_content: '',
        iframeId: '',
        iframeMode: '',
        html_url: '',
        suggestion_chips_btn: storeMessages.suggestionChips,
      }
    }))
  }, [nudgeMessage, showNudge]);


  const openWidget = useCallback(() => {
    dispatch(setIsOpen(true));
    dispatch(setIsNudgeOpen(false));

    dispatch(sendMessageLogSubmission({ data : {
      message: getMessageByVurablizeEvent(VurbalizeEvents.NUDGE_MESSAGE_TEXT_CLICKED),
      content: nudgeMessage,
      event_name: VurbalizeEvents.NUDGE_MESSAGE_TEXT_CLICKED,
      event_data: {
        timestamp: Date.now(),
        messageText: nudgeMessage,
        searchTerm: getQueryParamValue('utm_term')
      },
    }}))
  }, [nudgeMessage]);

  const nudgeType = useAppSelector(
    (state) => state.chat.reqNudgeType
  );
  const nudgeConfig = useAppSelector(
    (state) => state.chat.requestNudgeConfig
  );
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const fetchNudge = async () => {
      try {
        if (nudgeConfig) {
          const timeout = nudgeConfig.timeout;
          timeoutId = setTimeout(() => {
            setShowNudge(true);
            dispatch(setIsNudgeOpen(true));
          }, timeout * 1000);
        }
      } catch (err) {
        console.error("Error fetching nudge:", err);
      }
    };

    fetchNudge();

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [dispatch, nudgeType]);

  const isNudgeVisible  = useMemo(() => {
    if (!nudgeConfig) return false;
    return nudgeConfig.nudge_visible 
  }
  , [nudgeConfig]);


  if (!nudgeMessage || !showNudge || !isNudgeVisible || isOpen) return null;
  return (
    <NudgeContainer className='voa_initial_nudge_container'>
      <CrossIconContainer
        type="button"
        onClick={closeNudge}
        className="voa_initial_nudge_cross_icon_container"
      >
        <NudgeBlurrer>
          <CrossIcon fill="black" width="15px" height="15px" />
        </NudgeBlurrer>
      </CrossIconContainer>

      <NudgeMessageContainer className="voa_initial_nudge_message_container">
        <NudgeBotMessageContainer className="voa_initial_nudge_bot_message_container">
          <Plug>
            <NudgeBlurrer>
              <div className="voa_avatar_container">
                <NudgeBotMessageAvatar
                  onClick={openWidget}
                  src={theme?.themeConfig?.nudge?.botMessage?.avatar?.src}
                  className="voa_avatar_image"
                />
              </div>
            </NudgeBlurrer>
          </Plug>

          <NudgeBlurrer>
            <NudgeBotMessageCloudContainer onClick={openWidget} className="voa_initial_nudge_bot_message_cloud_container">
              <NudgeBotMessageCloud
                isLAMessage={isLANudge}
                className="voa_initial_nudge_bot_message_cloud_body"
                dangerouslySetInnerHTML={{ __html: nudgeMessage }}
              />
            </NudgeBotMessageCloudContainer>

          </NudgeBlurrer>
        </NudgeBotMessageContainer>
      </NudgeMessageContainer>
    </NudgeContainer>
  )
};

export default Nudge;